import React from 'react';
import SelectInput from './SelectInput';

const LevelSelectInput = ({ register, errors, name, validationRules = { required: 'Level is required' } }) => {
  const levelOptions = [
    { value: '100', label: '100 Level' },
    { value: '200', label: '200 Level' },
    { value: '300', label: '300 Level' },
    { value: '400', label: '400 Level' },
    { value: '500', label: '500 Level' },
    { value: '600', label: '600 Level' },
  ];

  return (
    <SelectInput
      label="Level"
      name={name}
      register={register}
      errors={errors}
      options={levelOptions}
      validationRules={validationRules}
    />
  );
};

export default LevelSelectInput;
